import { render, staticRenderFns } from "./PaperlessTag.vue?vue&type=template&id=c78411a4"
import script from "./PaperlessTag.vue?vue&type=script&lang=js"
export * from "./PaperlessTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports